export default "__VITE_ASSET__DsL4$YIj__"